class YGCommonFuntion extends HTMLElement {
    loadScript(url, fn) {
        // if(url){
        //     let loadScript = document.createElement('script')
        //     loadScript.src = url
        //     document.body.appendChild(loadScript)
    
        //     loadScript.onload = () => {
                fn()
        //     }
            
        //     loadScript.onerror = () => {
        //         console.error('Script load error')
        //     }
        // }
	}
}

class YGSidebar extends HTMLElement {
    constructor() {
        super()
        this.open()
        this.clone()
    }
    open() {
        this.addEventListener("click",function(){
            let slibar = document.querySelector(".yg-sidebar")
            let slibarContent = slibar.querySelector('.yg-sidebar-discription')
            let contentTemplate = this.querySelector(".sidebar-content-template")

            slibarContent.innerHTML = contentTemplate.innerHTML
            document.querySelector('body').style.overflow = "hidden"
            slibar.classList.add("activate")
        })
    }
    clone() {
        let slibar = document.querySelector(".yg-sidebar")
        
        slibar.addEventListener("click",function(e){
            if (e.target.classList.contains('yg-sidebar-background') || e.target.classList.contains('sidebar-close')) {
                slibar.classList.remove("activate")
                document.querySelector('body').style.overflow = "auto"
            }
        })
    }
}

document.addEventListener("DOMContentLoaded",function(){
    if (!window.customElements.get('yg-sidebar')) {
        window.customElements.define('yg-sidebar',YGSidebar)
    }
})

// YG Preview Swiper
class YGPreviewSwiper extends YGCommonFuntion {
    constructor() {
        super();

        let url = this.getAttribute("data-load-script")
        this.loadScript(url,()=>{
            this.swiper()
        });
    }

    swiper(){
        let YGPreviewList = this.querySelector('.yg-preview-list')
        let YGVideoList = this.querySelector('.yg-video-list')
        let videoList = YGVideoList.querySelectorAll("video")
        if(!YGPreviewList && !YGVideoList) return
        let swiperPreview = new Swiper(YGPreviewList, {
            slidesPerView: 4,
            spaceBetween: 40,
            slideToClickedSlide: true,
            navigation: {
                nextEl: ".yg-preview-image .swiper-button-next",
                prevEl: ".yg-preview-image .swiper-button-prev",
            },
            scrollbar: {
              el: ".swiper-scrollbar",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                //当swiper宽度大于等于768
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                200: {
                    slidesPerView: 2,
                    spaceBetween: 10
                }
            },
        });
        new Swiper(YGVideoList, {
            slidesPerView: 1,
            spaceBetween: 10,
            effect: "fade",
            thumbs: {
              swiper: swiperPreview,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            on:{
                slideChangeTransitionEnd: function(){
                  let activeIndex = this.activeIndex
                  if(videoList){
                      videoList.forEach(function (video, index){
                        console.log(index , activeIndex)
                        if(index == activeIndex){
                            video.play()
                        } else {
                            video.pause()
                        }
                      })
                    }
                },
            }
        });
    }
}

if (!window.customElements.get("yg-preview-swiper")){
    window.customElements.define("yg-preview-swiper", YGPreviewSwiper);
} 

class YGVideoList extends HTMLElement {
    constructor() {
        super()
        window.addEventListener('resize',()=>{
            // 在窗口大小发生变化时执行的操作
            this.initStyle()
            this.toggleVideo()
        })

        window.dispatchEvent(new Event('resize'))
    }
    initStyle() {
        let windowWidth = window.innerWidth;

        if(windowWidth > 767){
            let videoHeight = this.querySelector('.yg-main-video').getBoundingClientRect().height
            this.querySelector('.yg-video-list').style.height = `${videoHeight}px`
        }else{
            let more = this.querySelector(".yg-more")
            let less = this.querySelector(".yg-less")
            let videoListBox = this.querySelector('.yg-video-list')
            let videoListLength = this.querySelectorAll('.yg-video-block__image').length
            let videoHeight = this.querySelector('.yg-video-block__image').getBoundingClientRect().height
            let showLength = 3

            videoListBox.style.height = `${showLength * videoHeight + (showLength - 1) * 20}px`

            more.addEventListener("click",()=>{
                showLength += 3
                let show = showLength >= videoListLength ? videoListLength:showLength

                videoListBox.style.height = `${show * videoHeight + (show - 1) * 20}px`
                if(show == videoListLength) {
                    more.style.display = 'none'
                    less.style.display = 'block'
                }
            })

            less.addEventListener('click', () => {
                showLength = 3
                videoListBox.style.height = `${showLength * videoHeight + (showLength - 1) * 20}px`

                less.style.display = 'none'
                more.style.display = 'block'
            })
        }
    }
    toggleVideo() {
        let videoList = this.querySelectorAll('.yg-video-block__image')
        let mainVideo = this.querySelector('.yg-main-video')
        let dialog = this.querySelector('.yg-video-block__dialog')
        let windowWidth = window.innerWidth;


        videoList.forEach(function(video){
            video.addEventListener("click",function(e){
                if(e.target.classList.contains('yg-video-block__open')){
                    let template = video.querySelector('.yg-video-block__template')
                    if (windowWidth > 767) {
                        mainVideo.innerHTML = template.innerHTML
                    }else{
                        dialog.innerHTML = template.innerHTML
                        document.querySelector('body').style.overflowY = 'hidden'
                        dialog.showModal()
                    }
                    videoList.forEach(function(video){
                        video.classList.remove('active')
                    })
                    video.classList.add('active')
                }
            })
        })

        dialog.addEventListener("click",function(e){
            if(e.target.classList.contains('yg-video-block__dialog')){
                document.querySelector('body').style.overflowY = 'auto'
                videoList.forEach(function(video){
                    video.classList.remove('active')
                })
                dialog.close()
            }
        })
    }
}

if (!window.customElements.get('yg-video-list')) {
    window.customElements.define('yg-video-list',YGVideoList)
}

class YGFoldedText extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        const titleEles = this.querySelector('.folded-title');
        const svgEles = this.querySelector('.folded-title svg');
        const foldedOpen = this.querySelector('.folded-open');
        const foldedClose = this.querySelector('.folded-close');
        const contentEles = this.querySelector('.folded-description');
        let status = false;

        titleEles.addEventListener('click', () => {
          foldedOpen.classList.toggle('hide');
          foldedClose.classList.toggle('hide');
            if (status) {
                contentEles.style.height = '0px';
                // svgEles.classList.remove('rotate');
                status = false;
            } else {
                contentEles.style.height = contentEles.scrollHeight + 'px';
                // svgEles.classList.add('rotate');
                status = true;
            }
        })
    }
}

if (!window.customElements.get('yg-folded-text')) {
    window.customElements.define('yg-folded-text',YGFoldedText)
}

var YGRecentBlogPost = class extends YGCommonFuntion {
    constructor() {
        super();

        let url = this.getAttribute("data-load-script")
        this.loadScript(url,()=>{
            this.swiper()
        });
    }

    swiper(){
        let swiperItem = this.querySelector('.yg-blog-posts')
        new Swiper(swiperItem, {
            slidesPerView: 1.2,
            spaceBetween: 15,
            breakpoints: {
              //当宽度大于等于768
              768: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
              //当宽度大于等于1280
              1280: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
              //当宽度大于等于1680
              1680: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              }
            },
            scrollbar: {
              el: ".swiper-scrollbar",
              draggable: true
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
        })
    }
}

if (!window.customElements.get('yg-recent-blog-post')) {
    window.customElements.define('yg-recent-blog-post',YGRecentBlogPost)
}

var YGRecommendSwiper = class extends YGCommonFuntion {
    constructor() {
        super();

        let url = this.getAttribute("data-load-script")
        this.loadScript(url,()=>{
            this.swiper();
            this.init();
        });
    }

    swiper(){
        let swiperItem = this.querySelector('.yg-recommend-swiper')
        new Swiper(swiperItem, {
            slidesPerView: 1.2,
            spaceBetween: 20,
            breakpoints: {
              //当宽度大于等于768
              500: {
                slidesPerView: 2,
                spaceBetween: 30
              },
              768: {
                slidesPerView: 3.4,
                spaceBetween: 30
              },
              //当宽度大于等于1280
              1280: {
                slidesPerView: 3.8,
                spaceBetween: 30
              },
              //当宽度大于等于1680
              1680: {
                slidesPerView: 4.2,
                spaceBetween: 30
              }
            },
            scrollbar: {
              el: ".swiper-scrollbar",
              draggable: true
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
        })
    }

    init(){
        const mediaBtn = this.querySelectorAll('.yg-media-box-item');
      const mediaPopup = this.querySelectorAll('.yg-media-box-popup');
      const mediaSection = this.querySelectorAll('.yg-media-box-section');
      const mediaClose = this.querySelectorAll('.yg-media-close');
      console.log(mediaBtn,mediaPopup,mediaSection,mediaClose)
      function toggleVideoPopup(index, action) {
        mediaPopup[index].classList[action]('hide');
        mediaSection[index].classList[action]('hide');
        mediaClose[index].classList[action]('hide');
        if(action === 'remove') {
          let innerHTML = mediaSection[index].innerHTML;
          mediaSection[index].innerHTML = innerHTML
        }
      }
  
      mediaBtn.forEach((button, index) => {
        button.addEventListener('click', (event) => {
          toggleVideoPopup(button.getAttribute('data-index'), 'remove');
          event.stopPropagation();
        });
      });
  
      mediaClose.forEach((button, index) => {
        button.addEventListener('click', (event) => {
          toggleVideoPopup(index, 'add');
          event.stopPropagation();
        });
      });
  
      this.addEventListener('click', function (event) {
        const isClickedInsideBox = Array.from(mediaSection).some(box => box.contains(event.target));
        const isClickedInsideBtn = Array.from(mediaBtn).some(btn => btn.contains(event.target));
  
        if (!isClickedInsideBox && !isClickedInsideBtn) {
          mediaPopup.forEach((popup, index) => {
            // popup.classList.add('hide');
            toggleVideoPopup(index, 'add');
            event.stopPropagation();
          });
        }
      });
    }
}


if (!window.customElements.get('yg-recommend-swiper')) {
    window.customElements.define('yg-recommend-swiper',YGRecommendSwiper)
}


var YGLogoSwiper = class extends YGCommonFuntion {
    constructor() {
        super();

        let url = this.getAttribute("data-load-script")
        this.loadScript(url,()=>{
            this.swiper()
        });
    }

    swiper(){
        let swiperItem = this.querySelector('.yg-logo-swiper')
        let logoBtnItems = Array.from(this.querySelectorAll('.yg-logo-image'))
        // let swiperLogoBtn= this.querySelector('.yg-logo-show-btn')
        let YGLogoSwiper = new Swiper(swiperItem, {
            slidesPerView: 1,
            spaceBetween: 10,
            scrollbar: {
              el: ".swiper-scrollbar",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoHeight: true, // 添加这一行
        })
        logoBtnItems.forEach((item,index)=>{
            item.addEventListener('click',()=>{
                logoBtnItems.forEach( item => item.classList.remove('is-active'))
                YGLogoSwiper.slideTo(index);
                logoBtnItems[index].classList.add('is-active')
            })
        })
    }
}


if (!window.customElements.get('yg-logo-swiper')) {
    window.customElements.define('yg-logo-swiper',YGLogoSwiper)
}

var YGPartnerSwiper = class extends YGCommonFuntion {
    constructor() {
        super();

        let url = this.getAttribute("data-load-script")
        this.loadScript(url,()=>{
            this.swiper()
        });
    }

    swiper(){
        let swiperItem = this.querySelector('.yg-partner-swiper')
        let YGLogoSwiper = new Swiper(swiperItem, {
            slidesPerView: 1,
            scrollbar: {
              el: ".swiper-scrollbar",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
            }
        })
    }
}


if (!window.customElements.get('yg-partner-swiper')) {
    window.customElements.define('yg-partner-swiper',YGPartnerSwiper)
}


class YGVideoSwiper extends YGCommonFuntion {
    constructor() {
      super()
      const url = this.getAttribute('data-load-script')
      this.loadScript(url, () => {
        this.init() // 调用自定义方法
      })
    }
  
    init() {
      const swiper = this.querySelector('.swiper');
  
      new Swiper(swiper, {
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 16,
              },
            1000: {
                slidesPerView: 2,
                spaceBetween: 50,
            },
            1440: {
                slidesPerView: 2,
                spaceBetween: 50,
            },
        }
      })
  
      const mediaBtn = this.querySelectorAll('.yg-media-box-item');
      const mediaPopup = this.querySelectorAll('.yg-media-box-popup');
      const mediaSection = this.querySelectorAll('.yg-media-box-section');
      const mediaClose = this.querySelectorAll('.yg-media-close');
      console.log(mediaBtn,mediaPopup,mediaSection,mediaClose)
      function toggleVideoPopup(index, action) {
        mediaPopup[index].classList[action]('hide');
        mediaSection[index].classList[action]('hide');
        mediaClose[index].classList[action]('hide');
      }
  
      mediaBtn.forEach((button, index) => {
        button.addEventListener('click', (event) => {
          toggleVideoPopup(button.getAttribute('data-index'), 'remove');
          event.stopPropagation();
        });
      });
  
      mediaClose.forEach((button, index) => {
        button.addEventListener('click', (event) => {
          toggleVideoPopup(index, 'add');
          event.stopPropagation();
        });
      });
  
      this.addEventListener('click', function (event) {
        const isClickedInsideBox = Array.from(mediaSection).some(box => box.contains(event.target));
        const isClickedInsideBtn = Array.from(mediaBtn).some(btn => btn.contains(event.target));
  
        if (!isClickedInsideBox && !isClickedInsideBtn) {
          mediaPopup.forEach((popup, index) => {
            // popup.classList.add('hide');
            toggleVideoPopup(index, 'add');
            event.stopPropagation();
          });
        }
      });
    }
  }
  
  if (!window.customElements.get('yg-video-swiper')) {
    window.customElements.define('yg-video-swiper', YGVideoSwiper)
  }

  var YGCertificatesSwiper = class extends YGCommonFuntion {
    constructor() {
        super();

        let url = this.getAttribute("data-load-script")
        this.loadScript(url,()=>{
            this.swiper()
        });
    }

    swiper(){
        let swiperItem = this.querySelector('.yg-certificates-swiper')
        new Swiper(swiperItem, {
            slidesPerView: 1.5,
            spaceBetween: 20,
            breakpoints: {
              //当宽度大于等于768
              500: {
                slidesPerView: 3,
                spaceBetween: 30
              },
              768:{
                slidesPerView: 4,
                spaceBetween: 30
              },
              1200:{
                slidesPerView: 5.5,
                spaceBetween: 30
              },
              1440:{
                slidesPerView: 6.5,
                spaceBetween: 30
              },
            },
            scrollbar: {
              el: ".swiper-scrollbar",
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
        })
    }
}


if (!window.customElements.get('yg-certificates-swiper')) {
    window.customElements.define('yg-certificates-swiper',YGCertificatesSwiper)
}

var YGBicycleSeriesSwiper = class extends YGCommonFuntion {
    constructor() {
        super();

        let url = this.getAttribute("data-load-script")
        this.loadScript(url,()=>{
            this.swiper()
        });
    }

    swiper(){
        let swiperItem = this.querySelector('.yg-bicycleseries-swiper')
        new Swiper(swiperItem, {
            slidesPerView: 1.2,
            spaceBetween: 20,
            breakpoints: {
              //当宽度大于等于768
              768: {
                slidesPerView: 3,
                spaceBetween: 20
              }
            },
            scrollbar: {
              el: ".swiper-scrollbar",
              draggable: true
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
        })
    }
}


if (!window.customElements.get('yg-bicycleseries-swiper')) {
    window.customElements.define('yg-bicycleseries-swiper',YGBicycleSeriesSwiper)
}

class YGBundleBuying extends HTMLElement {
    constructor() {
        super()
        this.init()
    }
    init() {
        this.tabToggle()
        this.variantToggle()
        this.viewMore()
    }

    tabToggle() {
        let tabs = this.querySelectorAll('.yg-tab')
        let contents = this.querySelectorAll('.yg-content')

        tabs[0].classList.add('active');
        contents[0].classList.add('active');

        tabs.forEach((tab, index)=>{
            tab.addEventListener('click',()=>{
                tabs.forEach((tab, index)=>{
                    tab.classList.remove('active')
                    contents[index].classList.remove('active')
                })
                tab.classList.add('active')
                contents[index].classList.add('active')
            })
        })
    }

    variantToggle() {
        let variants = this.querySelectorAll('.yg-content__variant')
        variants.forEach((variant, index)=>{
            if (!variant.classList.contains('required')) {
                variant.addEventListener('click',()=>{
                    variant.classList.toggle('active')

                    if(variant.classList.contains('yg-content__variant-discount')){
                        this.undataDiscountPrice()
                    }
                    if(variant.classList.contains('yg-content__variant-free-option')){
                      this.undataFreeQuantity()
                    }
                })
            }
        })
    }

    undataFreeQuantity() {
      let freeVariants = this.querySelectorAll('.yg-content__variant-free-option.active')
      let freeNumber = this.getAttribute('data-free-quantity')

      if(freeVariants.length >= freeNumber){
        let requiredVariants = this.querySelectorAll('.yg-content__variant-free-option:not(.active)')

        requiredVariants.forEach((requiredVariant)=>{
          requiredVariant.classList.add('required')
        })
      } else {
        let requiredVariants = this.querySelectorAll('.yg-content__variant-free-option:not(.active)')

        requiredVariants.forEach((requiredVariant)=>{
          requiredVariant.classList.remove('required')
        })
      }
    }

    undataDiscountPrice() {
        let discountVariants = this.querySelectorAll('.yg-content__variant-discount.active')

        if(discountVariants.length >= discountVariants[0].dataset.discountNumber) {
            discountVariants.forEach((discountVariant)=>{
                let price = discountVariant.dataset.price
                let discountPrice = discountVariant.dataset.price / 100 * (100 - discountVariant.dataset.discountPercentage)

                discountVariant.querySelector('.yg-content__variant-price').innerHTML = `<span class="yg-content__variant-price-old">${ Shopify.formatMoney(price, window.money_format) }</span> ${Shopify.formatMoney(discountPrice, window.money_format)}`
            })
        } else{
            discountVariants = this.querySelectorAll('.yg-content__variant-discount')
            discountVariants.forEach((discountVariant)=>{
                let price = discountVariant.dataset.price
                let compareAtPrice = discountVariant.dataset.compareAtPrice > price ? Shopify.formatMoney(discountVariant.dataset.compareAtPrice, window.money_format): ''
                
                discountVariant.querySelector('.yg-content__variant-price').innerHTML = `<span class="yg-content__variant-price-old">${ compareAtPrice }</span> ${Shopify.formatMoney(price, window.money_format)}`
            })
        }
    }
    
    viewMore() {
        let tabVariants = this.querySelectorAll('.yg-content')

        tabVariants.forEach((tabVariant, index)=>{
          let variantLength = tabVariant.querySelectorAll('.yg-content__variant-box').length
          let showLength = 4

          if (variantLength < showLength) {
            tabVariant.querySelector('.yg-view-more2').style.display = 'none'
          } else {
            let moreBtn = tabVariant.querySelector('.yg-view-more2')

            tabVariant.querySelectorAll('.yg-content__variant-box').forEach((variant, index)=>{
              if (index + 1 >= showLength) {
                console.log(variant);
                variant.style.display = 'none'
              }
            }) 

            moreBtn.addEventListener('click', ()=>{
              if (moreBtn.classList.contains('active')) {
                tabVariant.querySelectorAll('.yg-content__variant-box').forEach((variant, index)=>{
                  if (index + 1 >= showLength) {
                    console.log(variant);
                    variant.style.display = 'none'
                  }
                })

                moreBtn.textContent = 'View More'
                moreBtn.classList.remove('active')
              } else {
                tabVariant.querySelectorAll('.yg-content__variant-box').forEach((variant, index)=>{
                  console.log("123",index);
                  if (index + 1 >= showLength) {
                    variant.style.display = 'block'
                  }
                })

                moreBtn.textContent = 'View Less'
                moreBtn.classList.add('active')
              }

            })
          }
        })
    }
}
if (!window.customElements.get('yg-bundle-buying')) {
    window.customElements.define('yg-bundle-buying',YGBundleBuying)
}